import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-base-datos-definicion',
  templateUrl: './base-datos-definicion.component.html',
  styleUrls: ['./base-datos-definicion.component.scss']
})
export class BaseDatosDefinicionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
